<template>
	<div>
		<v-overlay
			:value="show"
			:opacity="0.6"
			z-index="10000"
		/>
		<v-snackbar
			v-model="show"
			:timeout="-1"
			color="primary"
			multi-line
			top
			centered
			class="app-update-notification"
		>
			<div class="d-flex align-center">
				<v-icon class="mr-3" size="28" color="white">mdi-update</v-icon>
				<div>
					<div class="text-subtitle-1 font-weight-bold white--text">
						{{ $t('app-update-available-title') }}
					</div>
					<div class="text-body-2 white--text mt-1">
						{{ $t('app-update-available-description') }}
					</div>
					<div v-if="isOnCall" class="text-body-2 red--text text--lighten-2 mt-2 font-weight-medium">
						{{ $t('app-update-blocked-on-call') }}
					</div>
				</div>
			</div>

			<template #action="{ attrs }">
				<div class="d-flex flex-column flex-sm-row">
					<v-btn
						text
						small
						color="white"
						class="mr-0 mr-sm-2 mb-2 mb-sm-0"
						v-bind="attrs"
						@click="handleLater"
					>
						{{ $t('later') }}
					</v-btn>
					<v-btn
						color="white"
						small
						class="primary--text font-weight-bold"
						:disabled="isOnCall"
						v-bind="attrs"
						@click="handleUpdate"
					>
						<v-icon small class="mr-1">mdi-refresh</v-icon>
						{{ $t('update-now') }}
					</v-btn>
				</div>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

const REMINDER_INTERVAL_MS = 10 * 60 * 1000; // 10 minutes

export default {
	name: "AppUpdateNotification",

	data() {
		return {
			show: false,
			skipWaitingCallback: null,
			reminderTimer: null
		};
	},

	computed: {
		...mapGetters("voice", ["isOnCall"])
	},

	mounted() {
		window.addEventListener("sw-update-available", this.handleUpdateAvailable);
	},

	beforeDestroy() {
		window.removeEventListener("sw-update-available", this.handleUpdateAvailable);
		this.clearReminderTimer();
	},

	methods: {
		handleUpdateAvailable(event) {
			this.skipWaitingCallback = event.detail?.skipWaiting;
			this.show = true;
			this.clearReminderTimer();
		},

		handleUpdate() {
			if (typeof this.skipWaitingCallback === "function") {
				this.skipWaitingCallback();
			}

			this.show = false;
			this.clearReminderTimer();
		},

		handleLater() {
			this.show = false;
			this.startReminderTimer();
		},

		startReminderTimer() {
			this.clearReminderTimer();

			this.reminderTimer = setTimeout(() => {
				if (this.skipWaitingCallback) {
					this.show = true;
				}
			}, REMINDER_INTERVAL_MS);
		},

		clearReminderTimer() {
			if (this.reminderTimer) {
				clearTimeout(this.reminderTimer);
				this.reminderTimer = null;
			}
		}
	}
};
</script>

<style scoped>
.app-update-notification {
	z-index: 10001;
}

.app-update-notification >>> .v-snack__wrapper {
	border-radius: 12px;
	min-width: 340px;
}

.app-update-notification >>> .v-snack__content {
	padding: 16px;
}
</style>
